import { routes } from '../../routes';

export enum ActivityType {
  EXPERIENCE_CREATED = 'EXPERIENCE_CREATED',
  EXPERIENCE_EDITED = 'EXPERIENCE_EDITED',
  EXPERIENCE_DELETED = 'EXPERIENCE_DELETED',
  EXPERIENCE_OPENED = 'EXPERIENCE_OPENED',
  EXPERIENCE_CLOSED = 'EXPERIENCE_CLOSED',
  AUDIENCE_JOINED = 'AUDIENCE_JOINED',
  EVENT_CREATED = 'EVENT_CREATED',
  EVENT_EDITED = 'EVENT_EDITED',
  EVENT_DELETED = 'EVENT_DELETED',
  VENUE_CREATED = 'VENUE_CREATED',
  VENUE_EDITED = 'VENUE_EDITED',
  VENUE_DELETED = 'VENUE_DELETED',
  ACCESS_CODE_CREATED = 'ACCESS_CODE_CREATED',
  ACCESS_CODE_DELETED = 'ACCESS_CODE_DELETED',
  SURVEY_CREATED = 'SURVEY_CREATED',
  SURVEY_EDITED = 'SURVEY_EDITED',
  SURVEY_DELETED = 'SURVEY_DELETED',
  AUDIENCE_EDITED = 'AUDIENCE_EDITED',
  CAMPAIGN_CREATED = 'CAMPAIGN_CREATED',
  CAMPAIGN_EDITED = 'CAMPAIGN_EDITED',
  CAMPAIGN_DELETED = 'CAMPAIGN_DELETED',
  CAMPAIGN_SENT = 'CAMPAIGN_SENT',
  CAMPAIGN_SCHEDULED_SENT = 'CAMPAIGN_SCHEDULED_SENT',
  TICKET_POOL_ADDED = 'TICKET_POOL_ADDED',
  TICKET_POOL_EDITED = 'TICKET_POOL_EDITED',
  TAG_CREATED = 'TAG_CREATED',
  DIGEST_NEW_POSITIONS = 'DIGEST_NEW_POSITIONS',
  DIGEST_NEW_RESPONSES = 'DIGEST_NEW_RESPONSES',
  DIGEST_NEW_MEMBERS = 'DIGEST_NEW_MEMBERS',
}

export enum ActivityActorKind {
  FGO = 'FGO',
  COMPANY_ADMIN = 'COMPANY_ADMIN',
  BACKOFFICE = 'BACKOFFICE',
  SYSTEM = 'SYSTEM',
}

export interface ActivityActorView {
  kind: ActivityActorKind;
  userId?: string;
  displayName?: string;
}

export interface ActivitySubjectView {
  id?: string;
  name: string;
}

export interface ActivityView {
  id: string;
  occurredAt: string;
  type: ActivityType;
  actor: ActivityActorView;
  subject?: ActivitySubjectView;
  count?: number;
}

export interface ActivityFeedQuery {
  limit?: number;
  offset?: number;
}

export const activityTypeRoutes: Record<ActivityType, string> = {
  [ActivityType.EXPERIENCE_CREATED]: routes.experiences,
  [ActivityType.EXPERIENCE_EDITED]: routes.experiences,
  [ActivityType.EXPERIENCE_DELETED]: routes.experiences,
  [ActivityType.EXPERIENCE_OPENED]: routes.experiences,
  [ActivityType.EXPERIENCE_CLOSED]: routes.experiences,
  [ActivityType.AUDIENCE_JOINED]: routes.audiences,
  [ActivityType.EVENT_CREATED]: routes.events,
  [ActivityType.EVENT_EDITED]: routes.events,
  [ActivityType.EVENT_DELETED]: routes.events,
  [ActivityType.VENUE_CREATED]: routes.venues,
  [ActivityType.VENUE_EDITED]: routes.venues,
  [ActivityType.VENUE_DELETED]: routes.venues,
  [ActivityType.ACCESS_CODE_CREATED]: routes.protectionCodes,
  [ActivityType.ACCESS_CODE_DELETED]: routes.protectionCodes,
  [ActivityType.SURVEY_CREATED]: routes.surveys,
  [ActivityType.SURVEY_EDITED]: routes.surveys,
  [ActivityType.SURVEY_DELETED]: routes.surveys,
  [ActivityType.AUDIENCE_EDITED]: routes.audiences,
  [ActivityType.CAMPAIGN_CREATED]: routes.communicationCampaigns,
  [ActivityType.CAMPAIGN_EDITED]: routes.communicationCampaigns,
  [ActivityType.CAMPAIGN_DELETED]: routes.communicationCampaigns,
  [ActivityType.CAMPAIGN_SENT]: routes.communicationCampaigns,
  [ActivityType.CAMPAIGN_SCHEDULED_SENT]: routes.communicationCampaigns,
  [ActivityType.TICKET_POOL_ADDED]: routes.experiences,
  [ActivityType.TICKET_POOL_EDITED]: routes.experiences,
  [ActivityType.TAG_CREATED]: routes.tags,
  [ActivityType.DIGEST_NEW_POSITIONS]: routes.experiences,
  [ActivityType.DIGEST_NEW_RESPONSES]: routes.surveys,
  [ActivityType.DIGEST_NEW_MEMBERS]: routes.users,
};
